export const DRAG_PREVIEW_WIDTH = 240;
export const DRAG_PREVIEW_HEIGHT = 180;

export const BOARD_DRAG_PREVIEW_WIDTH = 180;
export const BOARD_DRAG_PREVIEW_HEIGHT = 160;

// Pixels to offset the drag ghost so the cursor tip appears near the top-left corner of the preview
export const DRAG_GHOST_CURSOR_OFFSET = 16;

// Smaller than the default asset ghost so it does not cover the canvas while aiming a drop
export const CANVAS_ASSET_DRAG_PREVIEW_MAX_SIZE = 120;
